import axios from "axios";

const blogService = {
  getBlogsAsync() {
    return axios.get(
      "https://storage.googleapis.com/tech.maxico.xyz/blogs.json"
    );
    // , {
    //   "Access-Control-Allow-Origin": "https://tech.maxico.xyz"
    // });
  },
  getGitHubRepos() {
    // https://docs.github.com/en/rest/guides/getting-started-with-the-rest-api
    return axios.get("https://api.github.com/users/maxwn/repos");
  },
};

export default blogService;
